'use client';

import { AssetPathnameDeleted } from './AssetPathnameDeleted';
import { AssetPathnameResult } from './AssetPathnameResult';
import type { AssetPathnameProps } from './types';

/**
 * Determine which pathname to show for an asset in a search result
 */
export const AssetPathname = ({
  ancestorFolders,
  project,
  isDeleted,
}: AssetPathnameProps) =>
  isDeleted ? (
    <AssetPathnameDeleted project={project} />
  ) : (
    <AssetPathnameResult ancestorFolders={ancestorFolders} project={project} />
  );
